// -*- Mode: rjsx -*-
import React, { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';

import Slide from '@mui/material/Slide';


import MentorIcon from '@mui/icons-material/School';
import AssignedIcon from '@mui/icons-material/AssignmentInd';
import AvailableIcon from '@mui/icons-material/List';
import CallIcon from '@mui/icons-material/Phone';


import { FHMaterialStyles, FancyDate, FHTheme } from "../../../ui";

import { EMPTY_REQUEST } from '../../request';

function Request(props) {
    const requestKey = props.entity.data;
    const meta = props.entity.meta;
    
    const classes = FHMaterialStyles();    
    const dispatch = useDispatch();
    const history = useHistory();
//    const history = useSelector(state => state.history.byRequest[requestKey] || []);
    const request = useSelector(state => state.requests.byKey[requestKey] || EMPTY_REQUEST);
    
    // useEffect(() => {
    //     dispatch(fetchHistory({ key: requestKey, cursor: '' }));
    // }, [dispatch]);


    function goto() {
        history.push('/queue/request/' + requestKey);
    }
    
    return (

          <Card className={classes.queueOptionActionArea} >

            <CardHeader
              title={request.title}
              subheader={request.user.name}
            />
            
            <CardContent>
              <FancyDate date={request.date_updated} />
            </CardContent>

            <CardActions disableSpacing>
              <Tooltip arrow={true} title="Hide this for now">
                <Button size="small" color="secondary" onClick={(e) => props.dismiss(e)}  >Dismiss</Button>
              </Tooltip>
              
              <Tooltip arrow={true} title="Want to know more?">
                <Button
                  size="small"
                  color="primary"
                  onClick={(e) => goto(e)}
                  style={{ marginLeft: 'auto'}}>View Request</Button>
              </Tooltip>
              
            </CardActions>

          </Card>


    );
}

function Reason(props) {
    let reason = props.reason;
    // const [extra, setExtra] = useState(false);

    let chipMap = {
        'mentor': { icon: <MentorIcon />,
                    label: "Mentor",
                    color: "secondary"
                  },
        'assigned': { icon: <AssignedIcon />,
                      label: "Assigned",
                      color: "primary"
                    },
        'available': { icon: <AvailableIcon />,
                       label: "Available",
                       color: "normal"
                     },
        'call': { icon: <CallIcon />,
                  label: "Call",
                  color: "primary"
                },         
        
    };
//    console.log("reason.type: %o, chipMap[reason.type]: %o", reason.type, chipMap[reason.type]);
    return <Chip icon={chipMap[reason.type].icon}
                 color={chipMap[reason.type].color}
                 label={chipMap[reason.type].label} />;
}
function Reasons(props) {
    const entity = props.entity;
    const reasons = props.entity.meta.reasons;
    return (
        <>
          { reasons.map( (reason) => <Reason reason={reason} entity={entity} /> ) }
        </>
    );
}

function Option(props) {

    let entity = props.entity;
    let [id, setId] = useState(entity.meta.id);
    
    console.log("Entity: %o", entity);
    
    let mmm = {
        'available': { component: <Request />,
                       color: FHTheme.palette.queueAvailable },        
        'assigned': { component: <Request />,
                     color: FHTheme.palette.queueAssigned },
        'mentor': { component: <Request />,
                    color: FHTheme.palette.queueMentor },
        'call': { component: <Request />,
                  color: FHTheme.palette.queueCall },        
    };
    
    if(!entity.meta.id)
        return null;
    
    let optionMap = mmm[entity.meta.type];

    function dismiss(e) {
        e.preventDefault();
        
        if(props.dismiss)
            props.dismiss(entity);
    }

    const classes = FHMaterialStyles({ color: optionMap.color });
    let option = React.cloneElement(optionMap.component, { entity: entity, dismiss: dismiss });
    

    return (
      <Slide in={props.visible} direction={props.direction} timeout={100}>

        <Grid container direction="row">
          
          <Grid xs={3}></Grid>
          
          <Grid className={classes.queueOptionContainer} direction="row" container>
            
            <Grid item className={classes.queueOptionMetaContainer} xs={4}>


              
              <Grid container justifyContent="space-between"  direction="column" style={{ height: "100%" }}>
                <Grid item>
                  <h2>The next best thing...</h2>
                </Grid>
                <Grid item style={{ border: "solid 1px red"}}>
                  <Reasons entity={entity} />
                </Grid>
              </Grid>

              

              
            </Grid>
            
            <Grid item className={classes.queueOptionEntityContainer} xs={8} >
              { option }
            </Grid>
            
          </Grid>
          
          <Grid xs={3}></Grid>
          
        </Grid>
        
        
      </Slide>
    );

}


export default Option;
